// BusinessUnits.js
import React from 'react';
import { motion } from 'framer-motion';
import iconVerifLight from '../assets/iconos/icon-verif-light.webp';
import iconFoco from '../assets/iconos/icon-foco-light.webp';
import iconMano from '../assets/iconos/icon-mano-light.webp';


import CardIcon from './CardIcon';

const Valores = () => {
  // Datos de las unidades de negocio
  const unitsData = [
    { title: 'Innovación', description: 'Adoptamos y desarrollamos tecnologías avanzadas para ofrecer soluciones que lideren el cambio en la industria.', img: iconFoco },
    { title: 'Calidad y Eficiencia', description: ' La excelencia es el estándar en todo lo que hacemos, desde el diseño hasta la implementación.', img: iconVerifLight  },
    { title: 'Compromiso', description: 'Trabajamos de manera dedicada y responsable en cada proyecto, asegurando resultados que superen las expectativas.', img: iconMano },

  ];

  return (
    // Sección animada con framer-motion
    <motion.section
      id="Valores"
      className="pb-10" // Padding vertical de 10
      style={{
        backgroundColor: 'var(--background-color-typeA)', // Color de fondo

      }} // Altura mínima del 80% del viewport
      initial={{ opacity: 0 }} // Opacidad inicial
      animate={{ opacity: 1 }} // Opacidad final
      transition={{ duration: 1 }} // Duración de la transición

    >
      <div className="container mx-auto px-4 text-center ">
        <h4 className="text-3xl mb-12"
          style={{
            color: 'var(--primary-text-color) ',
            fontWeight: 'bold',
          }}>
          Nuestros Valores
        </h4>
        
        <div className="grid grid-cols-1 md:grid-cols-3 px-[10%] gap-6">
          {unitsData.map((unit, index) => (
            <CardIcon
              key={index}
              title={unit.title}
              description={unit.description}
              icon={unit.img}
            >
            </CardIcon>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Valores;


